import { cn } from "@/lib/utils"

interface PageLayoutProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  className?: string;
}

export function PageContainer({ children, className, ...props }: PageLayoutProps) {
  return <div className={cn("flex-1 bg-ctu-bg", className)} {...props}>{children}</div>;
}

export function PageContent({ children, className, ...props }: PageLayoutProps) {
  return <div className={cn("p-8 max-w-6xl mx-auto bg-white rounded-xl shadow-card my-5", className)} {...props}>{children}</div>;
}
